import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import styles from './profilebody.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { upadteCustomerPassThunk, setLoggedIn } from '../../../../Website/redux/customerSlice';

const ChangePassword = () => {

    const {Passwordloading} = useSelector((state)=>state.customer)

    const dispatch = useDispatch()
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showPassword, setShowPassword] = useState({
        current: false,
        new: false,
        confirm: false,
    });

    const togglePasswordVisibility = (field) => {
        setShowPassword((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    const handleLogout = () => {
        localStorage.clear();
        dispatch(setLoggedIn(false));
        window.location.href = '/';
    };

    const formik = useFormik({
        initialValues: {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
        },
        validationSchema: Yup.object({
            currentPassword: Yup.string().required('Current password is required'),
            newPassword: Yup.string()
                .min(6, 'Password must be at least 6 characters')
                .required('New password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('newPassword')], 'Passwords must match')
                .required('Confirm password is required'),
        }),
        onSubmit: async (values) => {
            console.log('Password Change Data:', values);
            const result = await dispatch(upadteCustomerPassThunk(values));
            if (upadteCustomerPassThunk.fulfilled.match(result)) {
                setShowSuccessModal(true);
            }
        },
    });

    return (
        <div className={`${styles.profilebodyContainer} ${styles.acPolish} ${styles.passwordSettingsCard}`}>
            <div className={styles.profileheader}>
                <h2>Change Password</h2>
                <p className={styles.acSubtitle}>Use at least 6 characters. You will need to log in again after changing it.</p>
            </div>

            <form onSubmit={formik.handleSubmit} className={styles.profilebodyContent}>
                <div className={styles.profilebodyDetails} style={{ width: '100%' }}>
                    <label className={styles.addCatLabel} style={{ width: '100%' }}>
                        Current Password
                        <div className={styles.logininputContainer}>
                            <input
                                type={showPassword.current ? 'text' : 'password'}
                                name="currentPassword"
                                placeholder="********"
                                value={formik.values.currentPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <FontAwesomeIcon
                                icon={showPassword.current ? faEyeSlash : faEye}
                                className={styles.loginpasswordIcon}
                                onClick={() => togglePasswordVisibility('current')}
                            />
                        </div>
                        {formik.touched.currentPassword && formik.errors.currentPassword ? (
                            <div className={styles.error}>{formik.errors.currentPassword}</div>
                        ) : null}
                    </label>

                    <div className={styles.passwordGrid}>
                        <label className={styles.addCatLabel}>
                            New Password
                            <div className={styles.logininputContainer}>
                                <input
                                    type={showPassword.new ? 'text' : 'password'}
                                    name="newPassword"
                                    placeholder="********"
                                    value={formik.values.newPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <FontAwesomeIcon
                                    icon={showPassword.new ? faEyeSlash : faEye}
                                    className={styles.loginpasswordIcon}
                                    onClick={() => togglePasswordVisibility('new')}
                                />
                            </div>
                            {formik.touched.newPassword && formik.errors.newPassword ? (
                                <div className={styles.error}>{formik.errors.newPassword}</div>
                            ) : null}
                        </label>

                        <label className={styles.addCatLabel}>
                            Confirm Password
                            <div className={styles.logininputContainer}>
                                <input
                                    type={showPassword.confirm ? 'text' : 'password'}
                                    name="confirmPassword"
                                    placeholder="********"
                                    value={formik.values.confirmPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <FontAwesomeIcon
                                    icon={showPassword.confirm ? faEyeSlash : faEye}
                                    className={styles.loginpasswordIcon}
                                    onClick={() => togglePasswordVisibility('confirm')}
                                />
                            </div>
                            {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                <div className={styles.error}>{formik.errors.confirmPassword}</div>
                            ) : null}
                        </label>
                    </div>

                    <div className={styles.acActions}>
                        <button type="submit" className={styles.savechanges}>
                            {Passwordloading ? 'Please wait...' : 'Change Password'}
                        </button>
                    </div>
                </div>
            </form>

            {showSuccessModal && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalContent}>
                        <h3>Password Updated</h3>
                        <p>Please log in again.</p>
                        <button onClick={handleLogout} className={styles.modalButton}>
                            Log In
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChangePassword;
